import React, { useEffect, useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import { Formik, Form } from "formik";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
} from "../../../../_metronic/_partials/controls";
import * as Yup from "yup";
import {
  createWebcareerscityAsync,
  updateWebcareerscityAsync,
  getWebcareerscityDetailAsync,
} from "../redux/webcareerscityApi";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

const AddWebCareersCity = () => {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [file, setFile] = useState({
    file: null,
    url: "",
  });
  const { selectedWebcareerscity } = useSelector(
    (state) => state.webcluescareerscity,
    shallowEqual
  );

  const id = params.id;

  useEffect(() => {
    if (id) {
      dispatch(getWebcareerscityDetailAsync(id));
    }
  }, []);

  useEffect(() => {
    if (selectedWebcareerscity?.imageUrl && id) {
      setFile({ file: null, url: selectedWebcareerscity.imageUrl });
    } else {
      setFile({
        file: null,
        url: "",
      });
    }
  }, [selectedWebcareerscity]);

  const initialValues = {
    slug: "",
    title: "",
  };
  const redirectBack = () => {
    history.push("/web_careers_city");
  };

  const addSchema = Yup.object().shape({
    slug: Yup.string()
      .trim()
      .required("Please enter slug"),
    title: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please enter webcareerscity Title"
      )
      .required("Please enter webcareerscity title"),
  });

  const convertToSlug = (str) => {
    return str
      .toLowerCase()
      .trim()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/-+/g, "-");
  };

  const uploadImage = (e) => {
    setFile({
      url: URL.createObjectURL(e.target.files[0]),
      file: e.target.files[0],
    });
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={
          selectedWebcareerscity && params?.id !== undefined
            ? selectedWebcareerscity
            : initialValues
        }
        validationSchema={addSchema}
        onSubmit={(values, { setSubmitting, setErrors, resetForm }) => {
          let data = null;
          data = new FormData();

          // Append text fields
          data.append("slug", values.slug);
          data.append("title", values.title);

          // Append image
          if (file && file.file) {
            data.append("image", file.file);
          } else if (values && values.image) {
            data.append("image", values.image);
          } else {
            if (selectedWebcareerscity?.imageUrl && id) {
              return true;
            }
            return dispatch(
              showSuccessSnackbar("error", "Please select image", 3000)
            );
          }

          setSubmitting(true);
          if (params?.id !== undefined) {
            dispatch(
              updateWebcareerscityAsync(
                data,
                setSubmitting,
                resetForm,
                redirectBack
              )
            );
          } else {
            dispatch(
              createWebcareerscityAsync(
                data,
                setSubmitting,
                resetForm,
                redirectBack
              )
            );
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleBlur,
          handleChange,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Card>
            <CardHeader
              title={
                <div className="form-group m-0 d-flex align-items-center">
                  <Link className="btn btn-link px-0" to="/web_careers_city">
                    <SVG
                      className="h-50 align-self-center"
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Navigation/Arrow-left.svg"
                      )}
                    />
                    Back
                  </Link>
                  <span className="pl-2">
                    {params?.id
                      ? "Edit web careers city"
                      : "Add web careers city"}
                  </span>
                </div>
              }
            ></CardHeader>
            <CardBody>
              <Row className="justify-content-center">
                <Col lg={8}>
                  <Form>
                    <div className="form-group">
                      <label className="form-label">Slug</label>
                      <input
                        placeholder="Enter Slug"
                        type="text"
                        name="slug"
                        className={
                          errors.slug && touched.slug
                            ? "form-control re_inputRouded is-invalid"
                            : "form-control re_inputRouded"
                        }
                        onChange={handleChange}
                        onBlur={(event) => {
                          let slug = event.target.value;
                          if (slug) {
                            slug = convertToSlug(slug);
                          }
                          setFieldValue("slug", slug);
                        }}
                        value={values.slug ? values.slug : ""}
                      />
                      {touched.slug && errors.slug ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.slug}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Title</label>
                      <input
                        placeholder="Enter Title"
                        type="text"
                        name="title"
                        className={
                          errors.title && touched.title
                            ? "form-control re_inputRouded is-invalid"
                            : "form-control re_inputRouded"
                        }
                        onChange={handleChange}
                        onBlur={(event) => {
                          let title = event.target.value;
                          setFieldValue("title", title);

                          if (!values.slug) {
                            setFieldValue("slug", convertToSlug(title));
                          }
                        }}
                        value={values.title ? values.title : ""}
                      />
                      {touched.title && errors.title ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.title}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Featured Image</label>
                      <div className="col-md-12 text-center mb-4">
                        <div
                          className="pro_img"
                          style={{
                            backgroundImage: `url(${file.url})`,
                            height: 120,
                            width: "100%",
                            borderRadius: 10,
                            backgroundSize: "contain",
                            border: "1px solid #cccccc",
                          }}
                        >
                          <input
                            type="file"
                            accept=".png, .jpg, .jpeg"
                            onChange={uploadImage}
                          />
                          <div
                            className="edt_img_btn"
                            style={{ fontSize: 14, paddingTop: 60 }}
                          >
                            <span className="material-icons">edit</span>EDIT
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0 mt-4">
                      <div className="mr-5 mb-1 mt-2">
                        <Link
                          className="btn btn-outline-blue"
                          to="/web_careers_city"
                        >
                          Close
                        </Link>
                      </div>
                      <div className="mb-1 mt-2">
                        <Button
                          variant="blue"
                          className="px-5 defpddng spinnerBtn"
                          size="lg"
                          type="submit"
                        >
                          {selectedWebcareerscity && params?.id !== undefined
                            ? "Update"
                            : "Submit"}
                          {/* {isSubmitting && (
                                                        <div className="ml-3 basic-verification-loader text-center">
                                                            <CircularProgress />
                                                        </div>
                                                    )} */}
                        </Button>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      </Formik>
    </>
  );
};
export default AddWebCareersCity;
